import { useEffect, useState } from "react";

import { Typography } from "@mui/material";

export function ElapsedTimer({ startedAt }: { startedAt: string }) {
  const [elapsed, setElapsed] = useState("");

  useEffect(() => {
    const compute = () => {
      const ms = Date.now() - new Date(startedAt).getTime();
      if (ms < 1000) setElapsed("0s");
      else if (ms < 60_000) setElapsed(`${(ms / 1000).toFixed(0)}s`);
      else
        setElapsed(
          `${Math.floor(ms / 60_000)}m ${Math.round((ms % 60_000) / 1000)}s`,
        );
    };
    compute();
    const id = setInterval(compute, 1000);
    return () => clearInterval(id);
  }, [startedAt]);

  return (
    <Typography
      component="span"
      variant="caption"
      sx={{ fontFamily: "monospace", color: "info.main", ml: 1 }}
    >
      {elapsed}
    </Typography>
  );
}
